import React from 'react';
import { observer } from 'mobx-react';
import ProfileFormScene from './ProfileFormScene';
import ContractService from '../../../core/services/ContractService';
import { toJS } from 'mobx';
import { Roles } from '../../../core/util';

const ProfileFormSceneContainer = () => {
  return (
    <ProfileFormScene
      showWebPageConfig={
        localStorage.role === Roles.COMPANY_MANAGER &&
        (localStorage.company === '5a846957a8605c0414e5a80e' ||
          toJS(ContractService.availableSkus.some((sku) => sku === 'teachers-web-page')))
      }
    />
  );
};

export default observer(ProfileFormSceneContainer);
